"use client";

import { useRef, useEffect } from "react";
import { injectHTML } from "./injectHTML";

interface AdGlobalScriptProps {
    code: string;
}

export function AdGlobalScript({ code }: AdGlobalScriptProps) {
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!containerRef.current) return;
        injectHTML(containerRef.current, code);
    }, [code]);

    // Renders in the body but scripts execute globally
    return <div ref={containerRef} style={{ display: "none" }} />;
}
